import context from 'chimera/all/store/context'

export default context
